export default __webpack_public_path__ + "static/feature-importances-long-8a475f9f2bc82245e6cab14456cc5198.webp";